// Port of api/fuel/app/classes/filter/core/template.php
// Routes to type-specific template classes.

import F from 'offline/filter/constants'

function deepMerge(template, values) {
	if (Array.isArray(template)) return values === undefined ? template.slice() : values
	if (!template || typeof template !== 'object') return values === undefined ? template : values

	var result = {}
	var valueObject = values && typeof values === 'object' ? values : {}
	var keys = Object.keys(template)
	var i

	for (i = 0; i < keys.length; i++) {
		var key = keys[i]
		if (valueObject[key] !== undefined) {
			result[key] = deepMerge(template[key], valueObject[key])
		} else {
			result[key] = deepMerge(template[key], undefined)
		}
	}

	keys = Object.keys(valueObject)
	for (i = 0; i < keys.length; i++) {
		if (result[keys[i]] === undefined) result[keys[i]] = valueObject[keys[i]]
	}

	return result
}

var Template = {

	run: function(config, required, values) {
		var folder = F.TYPE_FOLDER[config.filterType]
		var mergedValues = deepMerge(required || {}, values || {})

		if (folder === 'games') {
			var GamesTemplate = require('offline/filter/template/games').default
			return GamesTemplate.fill(mergedValues)
		}
		if (folder === 'users') {
			var UsersTemplate = require('offline/filter/template/users').default
			return UsersTemplate.fill(mergedValues)
		}
		if (folder === 'lists') {
			var ListsTemplate = require('offline/filter/template/lists').default
			return ListsTemplate.fill(mergedValues)
		}
		if (folder === 'activities') {
			var ActivitiesTemplate = require('offline/filter/template/activities').default
			return ActivitiesTemplate.fill(mergedValues)
		}

		// Fallback: return values as-is
		return mergedValues
	},

	session: function(type, filter) {
		var folder = F.TYPE_FOLDER[type]

		if (folder === 'games') {
			var GamesTemplate = require('offline/filter/template/games').default
			return GamesTemplate.session(filter)
		}
		if (folder === 'users') {
			var UsersTemplate = require('offline/filter/template/users').default
			return UsersTemplate.session(filter)
		}
		if (folder === 'lists') {
			var ListsTemplate = require('offline/filter/template/lists').default
			return ListsTemplate.session(filter)
		}
		if (folder === 'activities') {
			var ActivitiesTemplate = require('offline/filter/template/activities').default
			return ActivitiesTemplate.session(filter)
		}

		return false
	}

}

export default Template
